import { Accordion } from "components/ui/Accordion";

import { ConsultationNotesReviewPanel } from "../ConsultationNotesReviewPanel";
import { MedicationReviewPanel } from "../MedicationReviewPanel";
import style from "./CdmReviewReferences.module.css";

// Reference panels (medication + consultation-notes review) shown alongside every
// step of a CDM/PP/OCF review. This is the DISPLAY layer — currently an Accordion;
// to switch to a modal later, change only this component. The panels themselves
// stay presentation-agnostic.
export const CdmReviewReferences = ({ patientId }) => (
  <Accordion
    className={style.noPaddingBottom}
    items={[
      {
        id: "medication-review",
        title: "Medication Review",
        content: <MedicationReviewPanel patientId={patientId} />,
      },
      {
        id: "consultation-notes-review",
        title: "Consultation Notes Review",
        content: <ConsultationNotesReviewPanel patientId={patientId} />,
      },
    ]}
  />
);
